export * from './login2.component';
